<template>
  <header class="page-header">
    <div class="nav-wrap clearfix">
      <img src="@/assets/images/public/logo1.svg" @click="routerSkip('/')" alt="logo" class="nav-logo">
      <nav class="nav-list clearfix pc">
        <div :class="'nav-li '+(curNav=='home'?'active':'')" @click="routerSkip('/')">{{$t("header.nav1")}}</div>
        <div :class="'nav-li '+(curNav=='about'?'active':'')" ><div  @click="routerSkip('/about')">{{$t("header.nav2")}}</div>
        <div class="pull-list abso">
          <a @click="routerSkip('/about')">{{$t("header.nav2_1")}}</a>
          <a @click="routerSkip('/culture')">{{$t("header.nav2_2")}}</a>
          <a @click="routerSkip('/prize')">{{$t("header.nav2_3")}}</a>
          <a @click="routerSkip('/news')">{{$t("header.nav2_4")}}</a>
          <!-- <a @click="routerSkip('/download')">素材下载</a> -->
        </div>
        </div>
        <div :class="'nav-li '+(curNav=='tech'?'active':'')" ><div @click="routerSkip('/tech',1)">{{$t("header.nav3")}}</div>
          <div class="pull-list abso">
            <a @click="routerSkip('/tech',1)">{{$t("header.nav3_1")}}</a>
            <a @click="routerSkip('/tech',2)">{{$t("header.nav3_2")}}</a>
            <a @click="routerSkip('/tech',3)">{{$t("header.nav3_3")}}</a>
          </div>
        </div>
        <div :class="'nav-li '+(curNav=='program'?'active':'')" >
          <div @click="routerSkip('/program')">{{$t("header.nav4")}}</div>
          <div class="pull-list abso">
            <a @click="routerSkip('/program/list',1)">{{$t("header.nav4_1")}}</a>
            <a @click="routerSkip('/program/list',3)">{{$t("header.nav4_2")}}</a>
            <a @click="routerSkip('/program/list',2)">{{$t("header.nav4_3")}}</a>
            <a @click="routerSkip('/program/list',4)">{{$t("header.nav4_4")}}</a>
          </div>
        </div>

        <div :class="'nav-li '+(curNav=='sales'?'active':'')" @click="routerSkip('/sales')">{{$t("header.nav5")}}</div>
        
        <div :class="'nav-li '+(curNav=='contact'?'active':'')" >
          <div @click="routerSkip('/contact')">{{$t("header.nav6")}}</div>
          <div class="pull-list abso">
            <a @click="routerSkip('/contact')">{{$t("header.nav6")}}</a>
            <a @click="routerSkip('/problem')">{{$t("header.nav6_1")}}</a>
          </div>
        </div>
        <div class="nav-li rela nav-lang" style="padding-right: 0;"><a-icon type="global" /> {{nowLanguage=='cn'?'中文':'EN'}} <img src="@/assets/images/public/icon-arrow.png">
        <div class="pull-part"><span  @click="changeLanguage('cn')">中文</span><span  @click="changeLanguage('en')">English</span></div>
        </div>
      </nav>
      <nav class="nav-list clearfix mobile">
        <div class="nav-li nav-lang"  v-show="!showMenu"><a-icon type="global" /> {{nowLanguage=='cn'?'中文':'EN'}} <img src="@/assets/images/public/icon-arrow2.png">
          <div class="pull-part"><span  @click="changeLanguage('cn')">中文</span><span  @click="changeLanguage('en')">English</span></div>
        </div>
        <a-icon type="menu" class="nav-li icon-menu" v-show="!showMenu" @click="showMenu=true;showMenuEvent()"/>
        <a-icon type="plus" class="nav-li icon-close" v-show="showMenu" @click="showMenu=false;showMenuEvent()"/>
      </nav>
      <!-- <button @click="changeLanguage" style="position: fixed;right: 0">切换语言</button> -->
    </div>
    <div class="menu-list" v-show="showMenu">
      <a :class="curNav=='home'?'active':''" @click="showMenu=false;routerSkip('/')">{{$t("header.nav1")}}</a>
      <a :class="curNav=='about'?'active':''" @click="navColpase1=!navColpase1">{{$t("header.nav2")}}<a-icon type="minus" class="fr" v-show="navColpase1"/><a-icon type="plus" class="fr" v-show="!navColpase1"/></a>
      <div class="menu-li" v-show="navColpase1">
        <a @click="showMenu=false;routerSkip('/about')">{{$t("header.nav2_1")}}</a>
        <a @click="showMenu=false;routerSkip('/culture')">{{$t("header.nav2_2")}}</a>
        <a @click="showMenu=false;routerSkip('/prize')">{{$t("header.nav2_3")}}</a>
        <a @click="showMenu=false;routerSkip('/news')">{{$t("header.nav2_4")}}</a>
        <!-- <a @click="showMenu=false;routerSkip('/download')">素材下载</a> -->
      </div>
      <a :class="curNav=='tech'?'active':''" @click="navColpase2=!navColpase2">{{$t("header.nav3")}}<a-icon type="minus" class="fr" v-show="navColpase2"/><a-icon type="plus" class="fr" v-show="!navColpase2"/></a>
      <div class="menu-li" v-show="navColpase2">
        <a @click="showMenu=false;routerSkip('/tech',1)">{{$t("header.nav3_1")}}</a>
        <a @click="showMenu=false;routerSkip('/tech',2)">{{$t("header.nav3_2")}}</a>
        <a @click="showMenu=false;routerSkip('/tech',3)">{{$t("header.nav3_3")}}</a>
      </div>
      <a :class="curNav=='program'?'active':''" @click="navColpase3=!navColpase3">{{$t("header.nav4")}}<a-icon type="minus" class="fr" v-show="navColpase3"/>
        <a-icon type="plus" class="fr" v-show="!navColpase3"/></a>
      
      <div class="menu-li" v-show="navColpase3">
        <a @click="showMenu=false;routerSkip('/program/list',1)">{{$t("header.nav4_1")}}</a>
        <a @click="showMenu=false;routerSkip('/program/list',3)">{{$t("header.nav4_2")}}</a>
        <a @click="showMenu=false;routerSkip('/program/list',2)">{{$t("header.nav4_3")}}</a>
        <a @click="showMenu=false;routerSkip('/program/list',4)">{{$t("header.nav4_4")}}</a>
      </div>
      <a :class="curNav=='sales'?'active':''" @click="showMenu=false;routerSkip('/sales')">{{$t("header.nav5")}}</a>
      <a :class="curNav=='contact'?'active':''" @click="navColpase4=!navColpase4">{{$t("header.nav6")}}<a-icon type="minus" class="fr" v-show="navColpase4"/>
        <a-icon type="plus" class="fr" v-show="!navColpase4"/></a>
      
      <div class="menu-li" v-show="navColpase4">
        <a @click="showMenu=false;routerSkip('/contact')">{{$t("header.nav6")}}</a>
        <a @click="showMenu=false;routerSkip('/problem')">{{$t("header.nav6_1")}}</a>
      </div>
    </div>
  </header>
</template>

<script>
  import { localLanguageVal } from '@/utils/autoScale'
  import { monitorPV } from '@/main'
export default {
  name: 'pageLayoutHeader',
  data () {
    return {
        curNav:"home",
      nowLanguage: 'cn',
        showMenu:false,
        navColpase1:false,
        navColpase2:false,
        navColpase3:false,
        navColpase4:false,
    }
  },
    watch: {
        $route(val) {
            // console.log(val);
            // console.log(val.path.indexOf(this.$i18n.locale))
            if(val.path.indexOf("/"+this.$i18n.locale+"/")<0){

                localStorage.setItem('sensfootLanguage', val.path.split("/")[0])
                location.reload()
            }
          this.curNav=val.name
            monitorPV({page: this.$route.fullPath + ' '+this.$route.name})
        }
    },

  created () {
      monitorPV({page: this.$route.fullPath + ' '+this.$route.name})
      // console.log(this.$route)
      this.curNav=this.$route.name

    let localLanguage = localLanguageVal().replace("/","")
    this.$i18n.locale=localLanguage
    this.nowLanguage = localLanguage
  },
  methods: {
    changeLanguage(lang) {
        // console.log(lang)
        if(lang!=this.nowLanguage){
            this.nowLanguage = lang
            // this.$i18n.locale = lang
            // console.log("ln:"+this.nowLanguage)

            localStorage.setItem('sensfootLanguage',this.nowLanguage)
            location.reload()

        }

      // if (this.nowLanguage === 'cn') {
      //   this.nowLanguage = 'en'
      //   this.$i18n.locale = 'en'
      // } else {
      //   this.nowLanguage = 'cn'
      //   this.$i18n.locale = 'cn'
      // }

    },
      showMenuEvent(){
        // if(this.showMenu){
        //     document.getElementsByTagName("body")[0].style.overflowY="hidden"
        // }else{
        //     document.getElementsByTagName("body")[0].style.overflowY="auto"
        // }
      }
  },
}
</script>

<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"
  .page-header{
    position fixed;top 0;left 0;right 0;z-index 1000;margin: auto;height: 80px;background-color #fff;}
  .nav-wrap {
    rela(); maxWidth(); height: 100%;}
    .nav-logo {
      abso(); top 0; bottom 0; left 0.15rem; margin: auto; width 1.82rem; height: .42rem;cursor pointer;
    }
    .nav-list {
      fr(); height: 80px}
      .nav-li {
        fl();position relative; height: 100%; padding 0 .25rem; font-size 14px; line-height 80px; color #333333; cursor pointer
        &:hover  .pull-part{
          display :block;
        }
        .pull-part{abso();display:none;font-size:.14rem;text-align :center;background :#fff;border:1px solid #e5e5e5;border-radius 3px;margin-top:-16px;top:100%;
        &:before{content:'';abso();width:8px;height:8px;border:1px solid #e5e5e5;border-left :0;border-bottom :0;transform :rotate(-45deg);background #fff; top:-5px;left:50%;margin-left:-5px;}

          span{display :block;line-height:32px;padding:0 8px;
           &:hover{color: $standardColor}
            }
        }
  &:not(.nav-lang):hover{
    &:after{content:'';position absolute;width .24rem;height .03rem;background $standardColor;left:50%;margin-left -.12rem;top 56px;}
  }
        &:hover .pull-list{display block;
           &:before{content:'';position absolute;width 200vw;top 0;left -100vw;background #fff;height 100%;}

        }
        .pull-list{display none;font-size:.14rem;line-height .4rem;width:200%;text-align center;top 100%;left -50%;background #fff;padding-bottom .2rem;
          a{color:#666666;display block;position relative;
        &:hover{color:#333;}
        }
        }
      }
  .nav-li:not(.nav-lang):hover{

  }
      .nav-li:not(.nav-lang).active {
        color: $standardColor
      }

  @media screen and (max-width: 1000px){
    .nav-li{padding:0 .2rem;}
  }

    @media screen and (max-width: 768px){
      .page-header{height:1.1rem;border-bottom :.02rem solid #fafafa;}
      .nav-wrap{padding:0 .3rem;}
      .nav-logo{width:2.1rem;height:.5rem;    left: .3rem;}
      .nav-li{padding:0;font-size: .2rem;line-height:1.1rem;
        .anticon-global{font-size:.26rem;position: relative; top: .02rem;}
         img{width:.17rem;height:auto;}
      .pull-part{    font-size: .2rem;    margin-top: -.16rem;
        &:before{width: .16rem; height: .16rem; top: -.09rem; margin-left: -.08rem;}
        span{    line-height: 0.6rem; padding: 0 .24rem;}
      }
        &:hover{
          &:after{content:'';display none;}
        }
      }
      .nav-list {
        height 1.1rem;
      }
       .icon-menu,.icon-close{font-size:.45rem;color:#1166b2;margin-left:.38rem;position: relative; top: .1em;}
      .icon-close{right: -.1rem;font-size: .55rem;}
       .menu-list{position:fixed;width:100%;top:1.1rem;bottom:0;background :#fff;font-size:.32rem;overflow :auto;
       &>a{line-height:1.25rem;margin:0 .32rem;border-top:1px solid #f4f4f4;display :block;color:#333;
       &:first-child{border:0;}
         i{line-height:1.25rem;margin-right:.1rem;}
         &.active{ color: $standardColor}
       }

         .menu-li{background:#f4f4f4;line-height :.8rem;padding:.2rem .32rem;margin:0;font-size:.28rem;
           a{display :block;color:#666;}
         }
       }

    }
</style>
<style>
  .icon-close svg{transform: rotate(45deg);}
</style>
